module.exports = __webpack_public_path__ + "static/media/pic1.3ba305ac.jpg";